import { render, staticRenderFns } from "./AddPermissionModal.vue?vue&type=template&id=0b2d16ff&scoped=true&"
import script from "./AddPermissionModal.vue?vue&type=script&lang=js&"
export * from "./AddPermissionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPermissionModal.vue?vue&type=style&index=0&id=0b2d16ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2d16ff",
  null
  
)

export default component.exports